<app-autocomplete
  label="Selecione um modelo de mensagem"
  placeholder="Buscar mensagem"
  (optionSelected)="handleOptionSelected($event)"
  [options]="options"
  [isDisabled]="disabled"
  [initialValue]="value"
  [openOnFocus]="true"
  [hasDescription]="true"
>
  <ng-template #addOnRightTemplate>
    <app-icon>search</app-icon>
  </ng-template>
</app-autocomplete>
